if (typeof window !== 'undefined') {
	window.dataLayer = window.dataLayer || [];
}

const pushToDataLayer = (event: string, data: Record<string, any> = {}): void => {
	if (typeof window !== 'undefined') {
		window.dataLayer = window.dataLayer || [];

		const eventData: any = {
			event,
			...data,
		};

		window.dataLayer.push(eventData);
	}
};

export const pushEvent = ({ event, pageReferrer, action }: { event: AnalyticsEvents; pageReferrer?: string; action?: string }): void => {
	if (typeof window === 'undefined') return;
	const checkAndPush = () => {
		pushToDataLayer(event, {
			page_location: window.location.href,
			page_title: document.title || 'Unknown Page',
			...(pageReferrer && { page_referrer: pageReferrer }),
			...(action && { action }),
		});
	};

	checkAndPush();
};

export enum AnalyticsEvents {
	VIRTUAL_PAGE_VIEW = 'virtual_page_view',
	MFA_ACTION = 'mfa_action',
}

export enum EventsParams {
	ADD_EMAIL = 'add_email',
	ADD_PHONE = 'add_phone',
	DELETE_EMAIL = 'delete_email',
	DELETE_PHONE = 'delete_phone',
	SWITCHED_EMAIL = 'switched_email',
	SWITCHED_PHONE = 'switched_phone',
}

declare global {
	interface Window {
		dataLayer: any[];
	}
}
